import React, { useState } from "react";
import fire from "../../../services/fire";
import firebase from "firebase/app";
import SaveAltRoundedIcon from "@material-ui/icons/SaveAltRounded";
import { Document, Page } from "react-pdf/dist/esm/entry.webpack";

function BulletinEntry({ entry, extra }) {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setPageNumber(1);
  };

  const changePage = (offset) => {
    setPageNumber((prevPageNumber) => prevPageNumber + offset);
  };

  const previousPage = () => {
    changePage(-1);
  };

  const nextPage = () => {
    changePage(1);
  };

  const handleClick = async () => {
    // console.log({ entry });
    await fire
      .firestore()
      .doc(`bulletin/${entry.id}`)
      .update({ views: firebase.firestore.FieldValue.increment(1) });
  };

  const control = numPages && (
    <div className="text-center">
      <p className="text-muted mediumfontsize">
        Page {pageNumber || (numPages ? 1 : "--")} of {numPages || "--"}
      </p>
      <button
        type="button"
        className="mr-1 btn btn-sm btn-outline-primary"
        disabled={pageNumber <= 1}
        onClick={previousPage}
      >
        Previous
      </button>
      <button
        type="button"
        className="ml-1 btn btn-sm btn-outline-primary"
        disabled={pageNumber >= numPages}
        onClick={nextPage}
      >
        Next
      </button>
    </div>
  );

  return (
    <div
      style={{ borderRadius: "8px" }}
      className="cardentry lightframecolor card p-0 mb-3"
    >
      <a
        href={entry.filelink}
        download
        target="_blank"
        rel="noopener noreferrer"
        className="cardentry"
        onClick={() => handleClick(entry)}
      >
        <div className="px-3 pt-3 pb-0">
          <h5 className="mb-1 text-danger dangerunderline pointer">
            {entry.title}
          </h5>
          <div className="mb-0 text-dark">
            {entry?.content && <>{entry?.content} </>}
          </div>
          <div className="float-left">
            <div className="text-muted mediumfontsize">
              {new Date(entry.created).toDateString()}
            </div>
          </div>
          <div className="float-right">
            {entry.filelink && (
              <div className="btn btn-primary btn-sm float-right">
                <div className="float-left" style={{ width: "25px" }}>
                  <SaveAltRoundedIcon className="adjusticon mr-1 biggerfontsize" />
                </div>
                Download
              </div>
            )}
          </div>
        </div>
      </a>
      {entry.showPreview && (
        <>
          <div className="clearfix py-4">{control}</div>
          <a
            href={entry.filelink}
            download
            target="_blank"
            rel="noopener noreferrer"
            className="cardentry m-1"
            onClick={() => handleClick(entry)}
          >
            {entry.filelink && (
              <div id="PDFContainer">
                <Document
                  className={"PDFDocument"}
                  file={entry.filelink}
                  onLoadSuccess={onDocumentLoadSuccess}
                  loading=""
                >
                  <Page
                    className={"PDFPage"}
                    pageNumber={pageNumber}
                    renderTextLayer={false}
                    renderInteractiveForms={false}
                    renderAnnotationLayer={false}
                  />
                </Document>
              </div>
            )}
          </a>
          <div className="py-4">{control}</div>
        </>
      )}
      {extra}
    </div>
  );
}

export default BulletinEntry;
